<template>
  <div v-cloak class="conten bg-f6">
    <toast ref="toast"></toast>
    <Header></Header>
    <coupon-default v-if="!couponObj.name"></coupon-default>
    <div v-else class="padding15">
        <div class="bgCoupon row employ" :class="{'receive':!couponObj.have}">
            <div class='ft11 gray-3 ilbk couponText padding10-left'>
                <!-- <p class='ft16'>{{couponObj.name}}</p> -->
                <p class='ft26 colf6'><span class="ft15">¥</span>{{couponObj.amount}}</p>
                <p>适用课程：{{couponObj.courseTitle}}</p>
                <p>使用期限：{{couponObj.startdate}}至{{couponObj.endDate}}</p>
            </div>
           
            <span class='priceBox ilbk text-center colf6'>
                <!-- <span class="ft15">¥</span>
                <span class="ft30">{{couponObj.amount}}</span> -->
                <p>
                     <span @click='goLearn' v-if='couponObj.have' class="ilbk  ft24 colf6 text-center">立即<br>使用</span>
                    <span @click='pullCopon' v-else class="ilbk colf6 ft24 text-center">立即<br>领取</span>
                    <!-- <span @click='goLearn' v-if='couponObj.have' class="ilbk couponBtn  ft12 text-center useBtn">立即使用</span>
                    <span @click='pullCopon' v-else class="ilbk couponBtn white ft12 text-center">立即领取</span> -->
                </p>
            </span>
        </div>
    </div>
  </div>
</template>

<script>
import Header from  '../../components/header'
import CouponDefault from '../../components/default/couponDefault'
import { getCoupon,pullCopon } from "../../model/coupon/couponServer";
export default {
  name: 'receiveCoupon',
  data(){
      return {
          couponList:[],
          couponObj:{
          }
      }
  },
  components: {
    Header,
    CouponDefault
  },
  created(){
    this.getCou()
  },
  methods: {
      getCou(){
        getCoupon(this.$route.query.aid).then(res=>{
            this.couponObj= res.data;
        })
      },
      pullCopon(){
        pullCopon({aid:this.$route.query.aid}).then( ()=>{
           this.getCou()
        }).catch(err => {
            this.$refs.toast.showToast(err.message)
        })
      },
      goLearn(){
        this.$router.push({
            path:'/details',
            query:{
                cid:this.couponObj.cid,
            }
        })
      },
  }
}
</script>
<style scoped lang="less">
.colf6{
    color:#FF6A30;
}
.bg-f6{
    background:rgba(246,246,246,1);
}
.bgCoupon{
    width: 100%;
    height: 104/20rem;
    box-sizing: border-box;
    // padding:0 0 0 .5rem;
    align-items: center;
}
.priceBox{
    width:92/20rem;
}
.couponText{
    width: 310/20rem;
    box-sizing: border-box;
    padding:0 .75rem 0 .75rem;
}
.employ{
    background-image: url('../../assets/imgs/coup1.png');
    background-size: 100% 100%;
    color:#FE6A30;
}
.receive{
    background-image: url('../../assets/imgs/getCp1.png');
    background-size: 100% 100%;
    color:#fff;
}
.couponBtn{
    width:74/20rem;
    height:28/20rem;
    line-height:28/20rem;
    margin-left:.25rem;
    background:linear-gradient(90deg,rgba(255,105,47,1),rgba(240,129,66,1));
    box-shadow:0px 0px 5px 0px rgba(241,132,69,0.45);
    border-radius:14px;
    margin-top:.5rem;
}
.useBtn{
    background:rgba(255,255,255,1);
    border:1px solid rgba(255,106,48,1);
    border-radius:16/20rem;
    color:#FF6A30;

}
</style>